import { QUERY_META } from "../../../queries/core/queryMeta";
import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { NavLink } from "react-router-dom";
import { Columns3 } from "lucide-react";
import { AuthContext } from "../../../auth/AuthContextInternal";
import { workApi } from "../../../api/marketingWorkboards";
import { useCrmLocale } from "../../../ui/locale/crmLocale";

export default function WorkboardsEntry() {
  const auth = useContext(AuthContext);
  if (!auth?.bootstrapResolved || !auth.user || auth.user.role === "student")
    return null;
  return (
    <EligibleWorkboardsEntry
      principal={`${auth.user.id}-${auth.user.simulation?.target_employee_id ?? ""}`}
    />
  );
}
function EligibleWorkboardsEntry({ principal }: { principal: string }) {
  const { t } = useCrmLocale();
  const session = useQuery({
    placeholderData: undefined,
    meta: QUERY_META.sensitive,
    queryKey: ["marketing", "work", "session", principal],
    queryFn: workApi.session,
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
  if (!session.data || session.isError) return null;
  const label = t("Workboards");
  return (
    <NavLink to="/marketing/work" aria-label={label} title={label}>
      <Columns3 size={18} />
      <span className="crm-nav-label">{label}</span>
    </NavLink>
  );
}
